var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.75C2.86193 4.75 2.75 4.86193 2.75 5V21C2.75 21.1381 2.86193 21.25 3 21.25H21C21.1381 21.25 21.25 21.1381 21.25 21V5C21.25 4.86193 21.1381 4.75 21 4.75H3ZM1.25 5C1.25 4.0335 2.0335 3.25 3 3.25H21C21.9665 3.25 22.75 4.0335 22.75 5V21C22.75 21.9665 21.9665 22.75 21 22.75H3C2.0335 22.75 1.25 21.9665 1.25 21V5Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 10C1.25 9.58579 1.58579 9.25 2 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H2C1.58579 10.75 1.25 10.4142 1.25 10Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 16C1.25 15.5858 1.58579 15.25 2 15.25H22C22.4142 15.25 22.75 15.5858 22.75 16C22.75 16.4142 22.4142 16.75 22 16.75H2C1.58579 16.75 1.25 16.4142 1.25 16Z",
    fill: "#BABABA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1.25C8.91421 1.25 9.25 1.58579 9.25 2V6C9.25 6.41421 8.91421 6.75 8.5 6.75C8.08579 6.75 7.75 6.41421 7.75 6V2C7.75 1.58579 8.08579 1.25 8.5 1.25Z",
    fill: "#BABABA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1.25C15.9142 1.25 16.25 1.58579 16.25 2V6C16.25 6.41421 15.9142 6.75 15.5 6.75C15.0858 6.75 14.75 6.41421 14.75 6V2C14.75 1.58579 15.0858 1.25 15.5 1.25Z",
    fill: "#BABABA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.25C8.91421 9.25 9.25 9.58579 9.25 10V22C9.25 22.4142 8.91421 22.75 8.5 22.75C8.08579 22.75 7.75 22.4142 7.75 22V10C7.75 9.58579 8.08579 9.25 8.5 9.25Z",
    fill: "#BABABA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 9.25C15.9142 9.25 16.25 9.58579 16.25 10V22C16.25 22.4142 15.9142 22.75 15.5 22.75C15.0858 22.75 14.75 22.4142 14.75 22V10C14.75 9.58579 15.0858 9.25 15.5 9.25Z",
    fill: "#BABABA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5.75C22.4142 5.75 22.75 6.08579 22.75 6.5V19.5C22.75 19.9142 22.4142 20.25 22 20.25C21.5858 20.25 21.25 19.9142 21.25 19.5V6.5C21.25 6.08579 21.5858 5.75 22 5.75Z",
    fill: "#BABABA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.75C2.41421 5.75 2.75 6.08579 2.75 6.5V19.5C2.75 19.9142 2.41421 20.25 2 20.25C1.58579 20.25 1.25 19.9142 1.25 19.5V6.5C1.25 6.08579 1.58579 5.75 2 5.75Z",
    fill: "#BABABA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 22C6.25 21.5858 6.58579 21.25 7 21.25H17C17.4142 21.25 17.75 21.5858 17.75 22C17.75 22.4142 17.4142 22.75 17 22.75H7C6.58579 22.75 6.25 22.4142 6.25 22Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6d094cab83199e10d4e3d117ee72d4dc.svg";
export { ForwardRef as ReactComponent };